var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"img-card",attrs:{"body-style":{
    padding: '0px',
    display: 'inline-block',
  }}},[_c('img',{staticClass:"img-card--image",style:({ 'max-width': `${_vm.maxWidth}px` }),attrs:{"src":_vm.url},on:{"click":function($event){_vm.imgDialog = true}}}),_c('el-dialog',{staticClass:"img-card__dialog",attrs:{"visible":_vm.imgDialog},on:{"update:visible":function($event){_vm.imgDialog=$event}}},[_c('img',{staticClass:"img-card__dialog--img",attrs:{"src":_vm.url}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }